import { render, staticRenderFns } from "./form15.vue?vue&type=template&id=2ff4a6ca&scoped=true&"
import script from "./form15.vue?vue&type=script&lang=js&"
export * from "./form15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4a6ca",
  null
  
)

export default component.exports